// extracted by mini-css-extract-plugin
export default {"item-content":"Center-module__item-content__ZQbnj","itemContent":"Center-module__item-content__ZQbnj"};